import { TagColor } from '@equip.health/ui';

export enum SurveyResponseStatus {
  NEW = 'New',
  REQUESTED = 'Requested',
  IN_PROGRESS = 'In progress',
  INCOMPLETE = 'Incomplete',
  DONE = 'Done',
  VOID = 'Void',
}

export const NOT_CREATED = 'Not created';

const NOT_STARTED = 'Not started';

const COMPLETED = 'Completed';

export const InquiryDetailViewSurveyResponseStatusDefinition: Record<
  Exclude<SurveyResponseStatus, SurveyResponseStatus.VOID> | typeof NOT_CREATED,
  { label: string; color: TagColor }
> = {
  [NOT_CREATED]: {
    color: TagColor.gray,
    label: NOT_CREATED,
  },
  [SurveyResponseStatus.INCOMPLETE]: {
    color: TagColor.gray,
    label: SurveyResponseStatus.INCOMPLETE,
  },
  [SurveyResponseStatus.NEW]: {
    color: TagColor.periwinkle,
    label: NOT_STARTED,
  },
  [SurveyResponseStatus.REQUESTED]: {
    color: TagColor.periwinkle,
    label: NOT_STARTED,
  },
  [SurveyResponseStatus.IN_PROGRESS]: {
    color: TagColor.pink,
    label: SurveyResponseStatus.IN_PROGRESS,
  },
  [SurveyResponseStatus.DONE]: {
    color: TagColor.green,
    label: COMPLETED,
  },
};
